import Vue from 'vue';
import dayjs from 'dayjs';


// datas

Vue.filter('formatoBrasileiro', data => {
    if (data && data.split) {
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano}`;
    } else {
      return '-';
    }
});

Vue.filter('mesAno', data => {
    const [ano, mes] = data.split('-');
    return `${mes}/${ano}`;
});

Vue.filter('dataHora', data => {
    if (!data) data = '';
    return (data && data.length >= 10) ? dayjs(data).format('DD/MM/YYYY HH:mm') : data;
});

Vue.filter('removeHora', data => {
  if (!data) data = '';
  return (data && data.length >= 10) ? dayjs(data).format('DD/MM/YYYY') : data;
});



// numeros

Vue.filter("NumeroDecimalPtBr", (num, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
    return Number(num).toLocaleString('pt-BR', { 
        minimumFractionDigits: minimumFractionDigits, 
        maximumFractionDigits: maximumFractionDigits,
    });
});

Vue.filter('cpf', data =>{
    if (data && data.length === 11) {
      return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return data;
});

Vue.filter('cnpj', data => {
    if (data && data.length === 14) {
      return data.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    return data;
  });


// abreviacoes

Vue.filter('capitalizarLocais', local => {
  // Separa a cidade e o estado (uf)
  let [cidade, uf] = local.split(' - ');

  // Capitaliza a cidade
  cidade = cidade.split(' ').map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase()).join(' ');

  // Verifica se a UF existe
  if (uf) {
    // Retorna no formato cidade-UF
    return `${cidade} - ${uf}`;
  } else {
    // Retorna apenas a cidade
    return cidade;
  }
});

